export default __webpack_public_path__ + "static/media/list_card1.a37e750a.svg";